import React, {Component} from 'react';
import {ControlLabel, FormControl, FormGroup} from "react-bootstrap";

export function createForm(meta, validate) {
    return meta.map((x , i) => {
        const { label, ...attr } = x;
        let vl = {};
        if (validate) {
            vl = validate;
            return (
                <FormGroup key={i} validationState={vl[x.name] ? 'success' : 'error'}>
                    <ControlLabel>{x.label}</ControlLabel>
                    <FormControl {...attr}/>
                </FormGroup>)
        } else {
            return (
                <FormGroup key={i}>
                    <ControlLabel>{x.label}</ControlLabel>
                    <FormControl {...attr}/>
                </FormGroup>)
        }



    })
}


// WEBPACK FOOTER //
// ./src/util/form.jsx